<script setup>
import {onMounted, computed, ref} from 'vue'
import { useStore } from 'vuex'
import {informationList} from "../../../constants/information";
import Accordion from  '../elements/Accordion.vue'
import {useRoute} from "vue-router";

const store = useStore()
const route = useRoute()
const anchorId = ref(null)
const linksFooter = computed(() => store.getters['links/GET_LINKS_FOOTER'])

const contractLinks = [
  {
    name: 'Договор',
    url: 'https://drive.google.com/file/d/1M7TnW2O6rRM9068NUVz9B65F6luPOIzP/view',
  },
  {
    name: 'Медсогласие',
    url: 'https://drive.google.com/file/d/1QFXs9NEDjusVu-zRT9vDTkFSyiWDSE3y/view?usp=sharing',
  },
]

const accordionItems = computed(() =>
    informationList.map(item => {
      if (item.title === 'Основные сведения и документы') {
        return {
          ...item,
          links: Object.fromEntries(
              Object.entries(linksFooter.value || {}).filter(([name]) =>
                  [
                    'Устав организации',
                    'Приказ о создании АНО СОЦ Берёзка',
                    'Свидетельство ОГРН',
                    'Сан-эпид.заключение 2025',
                    'Программа АНО СОЦ Берёзка 2025-2029 г.г.',
                    'Предварительный план смен лета 2026',
                  ].includes(name)
              )
          ),
        }
      }
      if (
          item.title ===
          'Материально-техническое обеспечение и оснащенность Организации'
      ) {
        return {
          ...item,
          links: Object.fromEntries(
              Object.entries(linksFooter.value || {}).filter(([name]) =>
                  ['Паспорта доступности'].includes(name)
              )
          ),
        }
      }
      if (
          item.title ===
          'Деятельность'
      ) {
        return {
          ...item,
          links: Object.fromEntries(
              Object.entries(linksFooter.value || {}).filter(([name]) =>
                  ['Приказ о создании АНО СОЦ Берёзка', 'Предварительный план смен лета 2026',].includes(name)
              )
          ),
        }
      }
      // if (item.title === 'Документы') {
      // 	return { ...item, links: linksFooter.value }
      // }
      if (
          item.title === 'Услуги, в том числе платные, предоставляемые Организацией'
      ) {
        return { ...item, contractLinks }
      }
      return item
    })
)

const scrollToAnchor = (anchorId) => {
  const element = document.getElementById(anchorId)
  if (element) {
    const headerHeight = 200
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerHeight
    console.log(offsetPosition)
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }
}

onMounted(() => {
  store.dispatch('links/fetchLinks')
  console.log(route)
  const hash = route.hash

  if (hash) {
    const anchor = hash.replace('#', '')
    anchorId.value = anchor
    scrollToAnchor(anchor)
  }
})
</script>

<template>
  <div id="information" class="information">
    <h2 class="information__title">Информация</h2>
    <Accordion
        v-for="info in accordionItems"
        :id="info.id"
        :is-active="anchorId === info.id"
        :key="info.title"
        :title="info.title"
        :description="info.description"
        :links="info.links"
        :contractLinks="info.contractLinks"
    />
  </div>
</template>

<style lang="scss" scoped>
.information {
  padding: 58px 0 0;
  max-width: 1080px;
  margin: 0 auto;

  @media screen and (max-width: 1300px) {
    max-width: 620px;
  }
  @media screen and (max-width: 680px) {
    padding: 120px 0 0;
    max-width: 300px;
  }

  &__title {
    font-family: RF Dewi Expanded;
    font-size: 64px;
    font-weight: 900;
    line-height: 77px;
    text-transform: uppercase;

    @media screen and (max-width: 1300px) {
      font-size: 46px;
      line-height: 55px;
    }
    @media screen and (max-width: 680px) {
      font-size: 24px;
      line-height: 29px;
    }
  }
}
</style>
